import { render, staticRenderFns } from "./ItemListSearchLayout.vue?vue&type=template&id=5af96caa&scoped=true"
import script from "./ItemListSearchLayout.vue?vue&type=script&lang=js"
export * from "./ItemListSearchLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af96caa",
  null
  
)

export default component.exports